import type { CarStatisticsPeriod } from '@taler/api-client'
import { type LocalDate, localDate, localDateParts } from '@taler/domain'

export function statisticsPeriodOf(year: number, today: LocalDate): CarStatisticsPeriod {
  const until = localDateParts(today).year === year ? today : localDate(year, 12, 31)
  return { from: localDate(year, 1, 1), until }
}
